let load = require('./helpers/browser/esm-js-loader-shards-super.js')(4);
module.exports = (load("eHzZ7")).then(() => parcelRequire('3qsva'));